import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
const Loader = ({ color = "black", height = 40, width = 40 }) => {
  return /* @__PURE__ */ jsx("div", { style: { fill: color, height: `${height}px`, width: `${width}px` }, children: /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", children: [
    /* @__PURE__ */ jsx("circle", { transform: "translate(8 0)", cx: "0", cy: "16", r: "0", children: /* @__PURE__ */ jsx(
      "animate",
      {
        attributeName: "r",
        values: "0; 4; 0; 0",
        dur: "1.2s",
        repeatCount: "indefinite",
        begin: "0",
        keyTimes: "0;0.2;0.7;1",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
        calcMode: "spline"
      }
    ) }),
    /* @__PURE__ */ jsx("circle", { transform: "translate(16 0)", cx: "0", cy: "16", r: "0", children: /* @__PURE__ */ jsx(
      "animate",
      {
        attributeName: "r",
        values: "0; 4; 0; 0",
        dur: "1.2s",
        repeatCount: "indefinite",
        begin: "0.3",
        keyTimes: "0;0.2;0.7;1",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
        calcMode: "spline"
      }
    ) }),
    /* @__PURE__ */ jsx("circle", { transform: "translate(24 0)", cx: "0", cy: "16", r: "0", children: /* @__PURE__ */ jsx(
      "animate",
      {
        attributeName: "r",
        values: "0; 4; 0; 0",
        dur: "1.2s",
        repeatCount: "indefinite",
        begin: "0.6",
        keyTimes: "0;0.2;0.7;1",
        keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
        calcMode: "spline"
      }
    ) })
  ] }) });
};
Loader.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
};
export default Loader;
